function loadSchedule() {
    const inputs = document.querySelectorAll('[data-name=form] select');
    const typeSelector = document.querySelector('[data-name=type]');

    for (var i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener('change', ajaxSchedule);
    }
    // inputs.forEach(input => input.addEventListener('change', ajaxSchedule));
    typeSelector.addEventListener('change', showSelects );
    showSelects();
    ajaxSchedule();
}

function showSelects() {
    var options = getOptions();
    options.auditory.classList.add('hidden');
    options.teacher.classList.add('hidden');
    options.group.classList.add('hidden');
    if (options.scheduleType.value == 'auditory') {
        options.auditory.classList.remove('hidden');
    } else if (options.scheduleType.value == 'teacher') {
        options.teacher.classList.remove('hidden');
    } else if (options.scheduleType.value == 'group') {
        options.group.classList.remove('hidden');
    }
}

function getOptions() {
    return {
        scheduleType: document.querySelector('[data-name=type]'),
        group: document.querySelector('[data-name=group]'),
        weekday: document.querySelector('[data-name=weekday]'),
        auditory: document.querySelector('[data-name=auditory]'),
        teacher: document.querySelector('[data-name=teacher]')
    };
}


function ajaxSchedule() {
    var options = getOptions();
    if (options.weekday.value && options.weekday.value !== '0') {
        var url = '/?type=11';
        url += '&scheduleType=' + options.scheduleType.value;
        url += '&weekday=' + options.weekday.value;

        if (options.scheduleType.value == 'auditory') {
            url += '&auditory=' + options.auditory.value;
        } else if (options.scheduleType.value == 'teacher') {
            url += '&teacher=' + options.teacher.value;
        } else if (options.scheduleType.value == 'group') {
            url += '&group=' + options.group.value;
        }
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            success: function(result) {
                resetLessons();
                resetAuditories();
                if ((result.lessons && result.lessons.length) || (result.diffs && result.diffs.length)) {
                    $('table.main-schedule').removeClass('hidden');
                    setLessons(result.lessons, result.type, false);
                    setLessons(result.diffs, result.type, true);
                } else if(result.auditories) {
                    setAuditories(result.auditories);
                } else {
                    noLessonsMessage();
                }
            }
        })
    }
}

function setAuditories(list) {
    var container = $('.all-auditory');
    var table = $('<table>' +
        '<tr>' +
        '<th>Аудитория</th>' +
        '<th>1</th>' +
        '<th>2</th>' +
        '<th>3</th>' +
        '<th>4</th>' +
        '<th>5</th>' +
        '<th>6</th>' +
        '<th>7</th>' +
        '</tr>' +
        '</table>');
    for(var key in list) {
        if(list.hasOwnProperty(key)){
            let row = $('<tr></tr>');
            row.append('<td>' + key +'</td>');
            table.append(row);
            for (var i = 0; i < list[key].length; i++) {
                var element = list[key][i];
                row.append(element
                    ? '<td class="orange-bg">' + element.subject + '<br/><nobr>' + element.teacher + '</nobr><br/>' + element.group + '</td>'
                    : '<td class="available"></td>'
                )
            }
            // list[key].forEach(element => row.append(element
            //         ? '<td class="orange-bg">' + element.subject + '<br/><nobr>' + element.teacher + '</nobr><br/>' + element.group + '</td>'
            //         : '<td class="available"></td>'
            //     )
            // );
        }
    }
    container.append(table);
}

function resetAuditories() {
    $('.all-auditory').get(0).innerHTML = '';
}

function noLessonsMessage() {
    $('.all-auditory').get(0).innerHTML = '<div>Занятий нет</div>';
}

function setLessons(lessons, type, important) {
    // lessons.forEach(lesson => {});
    for (var i = 0; i < lessons.length; i++) {
        let base = $('[data-number=' + lessons[i].number + ']');
        if (lessons[i].subgroup != 0) {
            $('[data-subgroup=0]', base).addClass('hidden');
            $('[data-subgroup=1], [data-subgroup=2]', base).removeClass('hidden');
        }
        let element = $('[data-subgroup=' + lessons[i].subgroup + ']', base);
        if (important) {
            element.addClass('attention')
        }
        element.get(0).innerHTML = lessons[i].subject;
        if (type != 'auditory') {
            element.get(0).innerHTML += ', ' + lessons[i].auditory;
        }
        if (type != 'teacher') {
            element.get(0).innerHTML += ', ' + lessons[i].teacher;
        }
        if (type != 'group') {
            element.get(0).innerHTML += ', ' + lessons[i].group;
        }
    }
}

function resetLessons() {
    $('table.main-schedule').addClass('hidden');
    $('[data-subgroup=0]')
        .removeClass('hidden attention')
        .each((index, element) => element.innerHTML = '');
    $('[data-subgroup=1], [data-subgroup=2]')
        .removeClass('attention')
        .addClass('hidden')
        .each((index, element) => element.innerHTML = '&#10005');
}

document.addEventListener("DOMContentLoaded", loadSchedule);


// WEBPACK FOOTER //
// ./Resources/Public/JavaScript/frontend.js